exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".floor-plan-icons[data-v-0b266cd8] {\n  display: block;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.floor-plan-icons .floor-plan-icon[data-v-0b266cd8] {\n  position: absolute;\n  transform: scale(1.4);\n  border-radius: 50%;\n  background: #ffffff30;\n  cursor: pointer;\n}", ""]);

// exports
